import styled from "styled-components";

export const Banner = styled.div`
  background-color: var(--title);
  display: flex;
  justify-content: center;
  align-items: center;

  #pather-div {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 43px;
    gap: 52px;

    #txt1 {
      font-weight: 700;
      font-size: 26px;
      line-height: 122%;
      color: var(--white);
      
      h2 {
        text-align: start;
        color: var(--white);
        text-transform: uppercase;
        line-height: 1em;

        span {
          font-size: 2.8rem;
          color: var(--orange);
        }
      }
      
      h3 {
        font-size: 1.5rem;
        color: var(--white);
        padding-top: 15px;
        font-weight: 400;
      }
    }

    #txt2 {
      font-weight: 700;
      font-size: 24px;
      line-height: 122%;
      color: var(--white);
      
      p {
        font-size: 22px;
        
        span {
          font-size: 46px;
          color: var(--orange);
        }
      }
    }
  }

  @media (min-width: 601px) {
    #pather-div {
      flex-direction: row;
      justify-content: space-between;

      #txt1 {

        h2 {
          font-size: 40px;
          line-height: 110%;
        }
      }

      #txt2 {

        p {
          font-size: 48px;
          line-height: 160%;
        }
      }
    }
  }
`;
